module.exports = __webpack_public_path__ + "static/media/Addclose.baacbec2.svg";